import { postJson, post } from '../../http'
export default {
  isEditPage(params) {
    return post('/ConfigureReports/BigScreenConfig/isEditPage', params)
  },
}
